import { useCallback } from 'react';
import { MemeFilters } from '../../../../data/Controllers/Memes/types';

interface FeedItemfilterButtonProps {
  filter: MemeFilters;
  selectedFilter: MemeFilters;
  onTap: (cat: MemeFilters) => Promise<void>;
  label: string;
}

export const FeedItemFilterButton = ({
  filter,
  selectedFilter,
  onTap,
  label,
}: FeedItemfilterButtonProps) => {
  const onClick = useCallback(() => {
    onTap(filter);
  }, [filter, onTap]);

  return (
    <div
      onClick={onClick}
      className={`btn feed-ui-top-category ${
        filter === selectedFilter ? 'selected' : ''
      }`}
    >
      <div className="feed-ui-top-category-label">{label}</div>
    </div>
  );
};
